import React from "react";
import { Drawer } from "antd";
import CreateUser from "../../../pages/Admin/CreateUser";
import CreateOrganization from "../../../pages/Admin/CreateOrganization";
import CreateCategory from "../../../pages/Category/CreateCategory";
import { sideDrawerTypes } from "../../../utils/comman";
import CreateDataElements from "../../../pages/DataElements/CreateDataElements";
import CreateBudget from "../../../pages/Budget/CreateBudget";
import DataEntryModel from "../../../pages/UserPages/DataEntryModel";

interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
  type: string;
  organizationData?: any;
  apiType?: string;
}

const SideDrawer: React.FC<SideDrawerProps> = ({
  open,
  onClose,
  type,
  organizationData,
  apiType,
}) => {
  return (
    <Drawer
      title={
        Object.keys(organizationData ?? {})?.length > 0
          ? `Edit ${sideDrawerTypes[type]}`
          : sideDrawerTypes[type]
          ? `Create ${sideDrawerTypes[type]}`
          : ""
      }
      placement="right"
      open={open}
      onClose={onClose}
      className="custom-sidedrawer"
    >
      <div className="sideDrawer-content-wrapper h-full p-[12px] 2xl:p-[26px]">
        {type === "user" && (
          <CreateUser
            userData={organizationData}
            open={open}
            onClose={onClose}
          />
        )}
        {type === "organization" && (
          <CreateOrganization
            organizationData={organizationData}
            open={open}
            onClose={onClose}
          />
        )}
        {type === "category" && (
          <CreateCategory
            categoryData={organizationData}
            open={open}
            onClose={onClose}
          />
        )}
        {type === "dataElement" && (
          <CreateDataElements
            dataElementData={organizationData}
            open={open}
            onClose={onClose}
          />
        )}
        {type === "budget" && (
          <CreateBudget
            budgetData={organizationData}
            open={open}
            onClose={onClose}
          />
        )}
        {type === "dataEntry" && (
          <DataEntryModel
            dataElementData={organizationData}
            open={open}
            onClose={onClose}
          />
        )}
      </div>
    </Drawer>
  );
};

export default SideDrawer;
